import pollForDefinition from './pollForDefinition';

const pollForWistiaPlayer = (elementRef, callback) => {
  pollForDefinition(window, 'Wistia', () => {
    const interval = setInterval(() => {
      if (elementRef.current && window.Wistia) {
        const player = window.Wistia.api(elementRef.current);
        if (player) {
          clearInterval(interval);
          callback(player);
        }
      } else {
        clearInterval(interval);
      }
    }, 250);
  });
};

export default pollForWistiaPlayer;
